import React from 'react';
import AsyncSelect from 'react-select/async/dist/react-select.esm';
import { AddPhotoIcon, MailIcon, PlusIcon, SearchIcon } from '../../components/Icons';
import Loader from '../../components/Loader';
import Avatar from '../../components/Avatar';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { LoadMoreButton } from 'components/generic-components/LoadMoreButton';

const Conversations = ({
  conversations,
  isLoadingConversations,
  selectConversationFromList,
  hasMoreConversations,
  getSelectUsetList,
  loadMoreConversations,
  search,
  setSearch,
  setActiveChatNew,
}) => {
  const { t } = useTranslation();
  return (
    <div className="participant-list">
      <div className="d-flex align-items-center search-cont p-2">
        <AsyncSelect
          cacheOptions
          loadOptions={getSelectUsetList}
          placeholder={t('Search ')}
          value={search}
          onChange={e => setSearch(e.value)}
          components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
          styles={{
            control: provided => ({ ...provided, border: 'none !important', boxShadow: 'none' }),
            container: provided => ({ ...provided, flex: 1, maxWidth: 300 }),
          }}
        />
        <SearchIcon width={24} style={{ margin: '0px 0.75rem' }} className="cursor-pointer" />
        <PlusIcon width={24} className="cursor-pointer ml-auto" onClick={setActiveChatNew} />
      </div>
      <p className="text-light-gray text-uppercase my-2 px-md-4 mx-1">{t('recent')}</p>
      <ul className="list-group list-group-flush">
        <Loader isLoadin={isLoadingConversations && conversations.length === 0}>
          {!!conversations.length &&
            conversations.map(el => (
              <li
                key={el.conversationId}
                className={`list-group-item list-group-item-action cursor-pointer ${el.unreadMessageCount > 0 ? 'unread' : ''
                  }`}
                onClick={() => selectConversationFromList(el)}
              >
                <div className="d-flex">
                  <Avatar size={48} image={el.conversationWith.avatar} />
                  <div className="overflow-hidden w-100 ml-3 d-md-block d-none">
                    <p>
                      <b>{el.conversationWith.name}</b>
                      <span className="text-light-gray">
                        {el.conversationWith.metadata &&
                          el.conversationWith.metadata.nickname &&
                          '\u00A0@' + el.conversationWith.metadata.nickname}
                      </span>
                    </p>
                    <div className="d-flex align-items-center overflow-hidden">
                      {el.lastMessage.type === 'text' && (
                        <>
                          <MailIcon height={16} width={16} />
                          <div className="flex-grow-1 overflow-hidden mx-2">
                            <p className="text-truncate text-light-gray ">{el.lastMessage.data.text}</p>
                          </div>
                        </>
                      )}
                      {el.lastMessage.type !== 'text' && (
                        <>
                          <AddPhotoIcon height={16} width={16} />
                          <div className="flex-grow-1 overflow-hidden mx-2">
                            <p className="text-truncate text-light-gray ">{el.lastMessage.data.attachments[0].name}</p>
                          </div>
                        </>
                      )}

                      <small className="text-light-gray text-nowrap">
                        {moment.unix(el.lastMessage.sentAt).fromNow()}
                      </small>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          {hasMoreConversations && (
            <Loader isLoadin={isLoadingConversations} height={36} size={28}>
              <LoadMoreButton handleLoadMore={loadMoreConversations} />
            </Loader>
          )}
        </Loader>
      </ul>
    </div>
  );
};

export default Conversations;
